//--------------- IMPORTAÇÃOES ---------------//
import api from "../../../services/api";



//--------------- FUNÇÃO ASSÍNCRONA LOAD USERS SERVICE ---------------//
// Responsável por requisitar à API os Usuários existentes
export default async function logoutService() {
    try {
        await api.post("/auth/logout", {}, { withCredentials: true });
        return true;
    } catch (err) {
        console.error("Erro ao realizar logout");
        return null;
    }
}